module.exports = __webpack_public_path__ + "img/EMT-OVCA_GSE227019.a7d34919.png";